import { render, staticRenderFns } from "./FluxoCaixaMovimentacoesList.vue?vue&type=template&id=a4d9963a"
import script from "./FluxoCaixaMovimentacoesList.vue?vue&type=script&lang=js"
export * from "./FluxoCaixaMovimentacoesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports